<div>
    <div class="card-grid-2-image-left">
        <div class="jobsdiv">
            <div class="image-box"><img src="{{job?.recruiter?.profileImage != null ? recruiterImagePath : ''}}{{job?.recruiter?.profileImage == null ? 'assets/images/profile-img.jpg':job?.recruiter?.profileImage}}" alt="jobBox"></div>
            <div class="right-info">
                <a class="name-job" href="javascript:void(0);">{{job?.recruiter?.companyName}}
                    <span *ngIf="job?.isfeatured == 1" class="featured">Featured</span>
                </a>
                <span class="location-small">{{job?.workPlaceLocation == "Remote" ? "Remote" : job?.location}}</span>
            </div>
        </div>
        <div class="apply">
            <img src="{{job?.saveStatus == 0 ?  'assets/images/ic_unsave.svg':'assets/images/saved_job.svg'}}"
                alt="unsave" (click)="saveUnsaveJob();$event.stopPropagation()" tooltip="Save" title="Save" placement="left">
        </div>
    </div>
    <div class="card-block-info">
        <div class="card-block-inner">
            <h6>{{job?.jobTitle}}</h6>
            <p class="salary">{{jobSalary(job)}}</p>
        </div>
    </div>
    <div class="cards-inner">
        <span class="card-time">Posted: {{dateInMilisecond(job?.createdAt) | dateAgoConvertor}}</span> <span style =" color:#DBD9D9"
        > |</span>
        <span class="card-applicants">{{job?.applicantsCount}} Applicants</span> <span style =" color:#DBD9D9"
        > |</span>
        <span class="card-briefcase">{{job?.employement_type?.name || "-"}}</span>
    </div>
</div>